import { buildRadarData } from '../PlayerOverview/PlayerRadar.Tile.helpers';

export const createPlayerSlice = (set, get) => ({
  // --- State ---
  playerOverviewRadarTraitData: {},
  playerOverviewRadarPerfData: {},
  passPlacementVideoOpen: false,
  passPlacementSelectedEvent: null,
  passPlacementSelectedEvents: [],
  passPlacementPlayAllActive: false,
  snapDistributionVideoOpen: false,
  snapDistributionSelectedEvent: null,
  snapDistributionSelectedEvents: [],
  /// --- Actions ---
  setPlayerOverviewRadarTraitData: (
    radarTraitData,
    traitTemplate,
    radarTraitComparisonData,
  ) => {
    const data = buildRadarData(
      radarTraitData,
      traitTemplate,
      radarTraitComparisonData,
    );
    set({ playerOverviewRadarTraitData: data });
  },
  setPlayerOverviewRadarPerfData: (
    radarPerfData,
    perfTemplate,
    radarPerfComparisonData,
  ) => {
    const data = buildRadarData(
      radarPerfData,
      perfTemplate,
      radarPerfComparisonData,
    );
    set({ playerOverviewRadarPerfData: data });
  },
  setSnapDistributionVideoOpen: (isOpen) => {
    set({ snapDistributionVideoOpen: isOpen });
  },
  setSnapDistributionSelectedEvent: (event) => {
    set({ snapDistributionSelectedEvent: event });
  },
  setSnapDistributionSelectedEvents: (events) => {
    set({ snapDistributionSelectedEvents: events });
  },
  isPassPlacementDragActive: () =>
    get().passPlacementSelectedEvents.length > 0 &&
    get().passPlacementPlayAllActive === false,
  setPassPlacementPlayAllActive: (isActive) => {
    set({ passPlacementPlayAllActive: isActive });
  },
  setPassPlacementVideoOpen: (isOpen) => {
    set({ passPlacementVideoOpen: isOpen });
  },
  setPassPlacementSelectedEvent: (event) => {
    set({ passPlacementSelectedEvent: event });
  },
  setPassPlacementSelectedEvents: (events) => {
    set({ passPlacementSelectedEvents: events });
  },
  selectEventAndOpenVideo: (event) => {
    set({
      passPlacementSelectedEvent: event,
      passPlacementVideoOpen: true,
    });
  },
  clearSelectionAndCloseVideo: () => {
    set({
      passPlacementSelectedEvent: null,
      passPlacementSelectedEvents: [],
      passPlacementVideoOpen: false,
      passPlacementPlayAllActive: false,
    });
  },
});
